"use client";

const CATEGORY_LABELS: Record<string, string> = {
  value: "估值",
  quality: "质量",
  growth: "成长",
  financialHealth: "财务健康",
  market: "市场",
};

const FACTOR_LABELS: Record<string, string> = {
  pe: "市盈率 PE",
  ev_ebitda: "EV / EBITDA",
  fcf_yield: "自由现金流收益率",
  roe: "净资产收益率 ROE",
  roic: "投入资本回报率 ROIC",
  operating_margin: "营业利润率",
  revenue_growth: "营收增长率",
  eps_growth: "每股收益增长率",
  debt_equity: "负债权益比",
  interest_coverage: "利息保障倍数",
  momentum_6m: "六个月动量",
  volatility: "年化波动率",
};

export type FactorAttributionView = {
  factorName: string;
  score: number;
  originalWeight: number;
  effectiveWeight: number;
  categoryContribution: number;
  totalContribution: number;
};

export type CategoryAttributionView = {
  category: string;
  score: number;
  originalWeight: number;
  effectiveWeight: number;
  contribution: number;
  factors: FactorAttributionView[];
  unavailableFactors: string[];
};

export type ScoreAttributionView = {
  modelVersion: string;
  totalScore: number | null;
  categories: CategoryAttributionView[];
  unavailableCategories: string[];
};

const number = (value: number) => value.toFixed(2);
const percent = (value: number) => `${(value * 100).toFixed(1)}%`;

export default function AttributionPanel({ attribution }: { attribution: ScoreAttributionView }) {
  return <section className="attribution-panel">
    <div className="attribution-heading">
      <div><small>SCORE ATTRIBUTION</small><h2>评分归因</h2></div>
      <div><span>模型版本</span><b>{attribution.modelVersion}</b></div>
    </div>
    <p className="attribution-summary">
      HongPan Score {attribution.totalScore === null ? "暂无" : number(attribution.totalScore)}，由以下可用分类按实际权重加总。缺失数据已自动跳过并重新归一化。
    </p>
    <div className="attribution-categories">
      {attribution.categories.map((category) => <details key={category.category}>
        <summary>
          <b>{CATEGORY_LABELS[category.category] ?? category.category}</b>
          <span>{number(category.score)} × {percent(category.effectiveWeight)}</span>
          <strong>= {number(category.contribution)}</strong>
        </summary>
        <div className="attribution-factor-head"><span>因子</span><span>评分</span><span>实际权重</span><span>分类贡献</span><span>总分贡献</span></div>
        {category.factors.map((factor) => <div className="attribution-factor" key={factor.factorName}>
          <span>{FACTOR_LABELS[factor.factorName] ?? factor.factorName}</span>
          <span>{number(factor.score)}</span>
          <span>{percent(factor.effectiveWeight)}</span>
          <span>{number(factor.categoryContribution)}</span>
          <strong>{number(factor.totalContribution)}</strong>
        </div>)}
        {category.unavailableFactors.length > 0 && <p className="attribution-missing">
          已跳过：{category.unavailableFactors.map((factor) => FACTOR_LABELS[factor] ?? factor).join("、")}；本分类其余因子权重已重新归一化。
        </p>}
      </details>)}
    </div>
    {attribution.unavailableCategories.length > 0 && <p className="attribution-missing category-missing">
      未参与总分：{attribution.unavailableCategories.map((category) => CATEGORY_LABELS[category] ?? category).join("、")}；其余分类权重已重新归一化。
    </p>}
  </section>;
}